export default "__VITE_ASSET__1NCmBp8O__"